import { Product } from '../../../../../types';
import { ProductPriceType } from '../../../types';

export const getFilter = (prices?: Product['prices']) => {
  const initialFilter = {
    hasInternationalPrices: false,
    hasUsedProducts: false,
    hasNotInMintCondition: false,
    hasPickupOnly: false,
    hasUnavailable: false,
    hasFilter: false,
  };
  if (!prices || !prices.nodes) {
    return initialFilter;
  }

  const hasInternationalPrices = prices.nodes.some(
    p => p && p.store && p.store.market !== 'primary'
  );
  const hasUsedProducts = prices.nodes.some(
    p => p && p.type === ProductPriceType.USED_PRODUCT
  );
  const hasNotInMintCondition = prices.nodes.some(
    p => p && p.type === ProductPriceType.NOT_IN_MINT_CONDITION
  );
  const hasPickupOnly = prices.nodes.some(
    p => p && p.type === ProductPriceType.PICKUP_ONLY
  );
  const hasUnavailable = prices.nodes.some(
    p => p && p.type === ProductPriceType.UNAVAILABLE
  );

  return {
    hasInternationalPrices,
    hasUsedProducts,
    hasNotInMintCondition,
    hasPickupOnly,
    hasUnavailable,
  };
};

export const getValidPriceType = (type?: string | null) => {
  if (
    !type ||
    !Object.values(ProductPriceType).includes(type as ProductPriceType)
  )
    return null;

  return type as ProductPriceType;
};
